import TextMetrics from './text-metrics';

export default function measureText(text, style, measureBox) {
    return TextMetrics.current.measure(text, style, measureBox);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/text-metrics/measure-text.js
// module id = 1347
// module chunks = 0